var scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded) return;
  // Allow loading if event is trusted OR if it's our programmatic call
  if (e && !e.isTrusted && e.type !== 'domready' && e.type !== 'timeout') return;
  scriptsLoaded = true;
  
  // Load ALL functional scripts immediately in parallel for fastest fully loaded time
  // No delays - all scripts load in parallel to complete faster
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/mattress-pdp-main-prod-javascript.js?v=122586088921700664441791178741");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/mattress-pdp-main-banner-javascript.js?v=108770971509229693701789017218");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/uid.js?v=30942278962362555661767598174");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/predictive-search.js?v=71507557593871791981763017396");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/global.events.js?v=24694680730709280421763017395");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/global.js?v=75764989038244340111758201150");
  loadScript("https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js");
  loadScript('https://bridge.shopflo.com/js/shopflo.bundle.js');
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/salearrangecallback.js?v=68474444134528594961793277289");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/extrajsfromthemejs.js?v=49061839294990908061755775277");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/lazy-video-intersection-observer-lazyscript.js?v=148607948365307469151747641882");
  loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/mattress-pdp-speed-review-javascript.js?v=30011203841231588161789972682");
  loadScript("https://cdn.shopify.com/extensions/78d1a909-02f9-430b-a819-8b063adf2e65/hulk-form-builder-3/assets/form-builder-script.js");
  loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/salearrangecallback.css?v=52112704097415008351793596279");
  loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/simply.css?v=79172038329448110321782208917");
  loadCSS("https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css");
  
  // Load Swiper and defer initialization to reduce TBT
  loadScriptWithCallBack('https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.1.1/swiper-bundle.min.js', function () {
    // Defer Swiper initialization using requestIdleCallback to reduce TBT
    var initSwiper = function() {
      var swiper = new Swiper(".testimonial-slider", {
        slidesPerView: 1.1,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          768: { slidesPerView: 2 },
          1244: { slidesPerView: 3 },
        },
      });
    };
    if (window.requestIdleCallback) {
      requestIdleCallback(initSwiper, { timeout: 2000 });
    } else {
      setTimeout(initSwiper, 1000);
    }
  });


  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
  document.removeEventListener('touchstart', loadScripts);
}

// Load scripts immediately on DOMContentLoaded for fastest fully loaded time
// No delay - scripts start loading as soon as DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    if (!scriptsLoaded) {
      loadScripts({ type: 'domready', isTrusted: true });
    }
  });
} else {
  // DOM already loaded, start immediately
  if (!scriptsLoaded) {
    loadScripts({ type: 'domready', isTrusted: true });
  }
}

// Also load on user interaction for faster response
document.addEventListener('mouseover', loadScripts, { once: true, passive: true });
document.addEventListener('click', loadScripts, { once: true, passive: true });
document.addEventListener('scroll', loadScripts, { once: true, passive: true });
document.addEventListener('touchstart', loadScripts, { once: true, passive: true });

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}